import React from 'react'
import WaterlineManagement from '../../../views/corp/waterline-management/WaterlineManagement'

const waterlineManagementRoutes = [
  {
    path: '/corp/waterline-management',
    element: <WaterlineManagement />
  }
]

export default waterlineManagementRoutes
